import React, { useCallback, useMemo } from "react";
import { Button, Layout } from "@folio/stripes/components";
import { useHistory, useLocation } from "react-router-dom";
import { navigation } from "./navigation";
import { hasAtLeastOneRole, isPublisherRoleOnly, useActiveRoles, } from "../utils/permissionsUtils";
/**
 * Navigation keys shown to users whose only roles are publisher roles
 * (PublisherAdmin/PublisherGuarantor, without AgencyWorker/Superuser).
 * The remaining routes stay reachable via direct links.
 */
var PUBLISHER_ONLY_NAV_KEYS = [
    "titles",
    "products",
    "productNumbers",
    "naturalPersons",
    "legalPersons",
    "collections",
    "publisherPrefixes",
    "outputs",
];
var NavigationComponent = function () {
    var history = useHistory();
    var pathname = useLocation().pathname;
    var activeRoles = useActiveRoles();
    var allowedRoutes = useMemo(function () {
        var publisherOnly = isPublisherRoleOnly(activeRoles);
        return Object.entries(navigation)
            .filter(function (_a) {
            var key = _a[0], route = _a[1];
            if (publisherOnly && !PUBLISHER_ONLY_NAV_KEYS.includes(key)) {
                return false;
            }
            return route.roles ? hasAtLeastOneRole(activeRoles, route.roles) : true;
        })
            .map(function (_a) {
            var route = _a[1];
            return route;
        });
    }, [activeRoles]);
    var handleClick = useCallback(function (path) {
        if (pathname !== path)
            history.push(path);
    }, [history, pathname]);
    return (React.createElement(Layout, { className: "padding-start-gutter padding-end-gutter" },
        React.createElement("div", { style: {
                backgroundColor: "#f5f5f5",
                padding: "1rem",
                borderRadius: "4px",
            } },
            React.createElement("h3", { style: { fontWeight: "bold", marginBottom: "1rem" } }, "Tabulky"),
            React.createElement("div", { style: { display: "flex", flexDirection: "column", gap: "1rem" } }, allowedRoutes.map(function (route) {
                var isActive = pathname === route.path;
                return (React.createElement(Button, { key: route.path, onClick: function () { return handleClick(route.path); }, buttonStyle: isActive ? "primary" : "default", fullWidth: true, marginBottom0: true, style: { justifyContent: "flex-start" }, "aria-current": isActive ? "page" : undefined },
                    React.createElement("span", { style: { marginLeft: "0.5rem" } }, route.label)));
            })))));
};
export default NavigationComponent;
